(() => {
  if (window.location.pathname === '/collections/all') { window.location.replace('/products/londonschoice'); return; }
  if (window.location.pathname === '/policies/shipping-policy') { window.location.replace('/pages/shipping-delivery'); return; }

  const normalize = (text) => (text || '').toLowerCase().replace(/\s+/g, '');
  const inferSize = (text) => {
    const value = normalize(text);
    if (value.includes('16oz')) return '16oz';
    if (value.includes('4oz')) return '4oz';
    if (value.includes('2oz')) return '2oz';
    if (value.includes('4l')) return '4l';
    return '';
  };
  const isAvailable = (option) => option?.dataset.available === 'true';
  const getCountry = () => document.querySelector('[data-lc-country]')?.dataset.lcCountry || window.Shopify?.country || '';
  const optionPriority = (option) => {
    const title = normalize(option.dataset.title || option.textContent);
    if (title.includes('4oz') && title.includes('glass')) return 1;
    if (title.includes('4oz') && title.includes('refill')) return 2;
    if (title.includes('2oz') && title.includes('refill')) return 3;
    if (title.includes('16oz') && title.includes('refill')) return 4;
    if (title.includes('2oz') && title.includes('glass')) return 5;
    if (title.includes('16oz') && title.includes('glass')) return 6;
    if (title.includes('4l')) return 7;
    return 99;
  };

  const syncScope = (scope) => {
    const select = scope.querySelector('[data-lc-variant-select]');
    if (!select) return;
    const options = [...select.options];
    options.forEach((option) => { option.dataset.size = inferSize(option.dataset.title || option.textContent); });
    scope.querySelectorAll('[data-lc-format-option]').forEach((button) => {
      const option = options.find((item) => String(item.value) === String(button.dataset.variantId));
      if (!option) return;
      button.dataset.size = option.dataset.size;
      button.dataset.sellable = String(isAvailable(option));
    });

    const requestedVariant = new URLSearchParams(window.location.search).get('variant');
    let chosen = requestedVariant ? options.find((option) => String(option.value) === String(requestedVariant) && isAvailable(option)) : null;
    if (!chosen) chosen = options.filter(isAvailable).sort((a, b) => optionPriority(a) - optionPriority(b))[0] || options[0];
    if (chosen) select.value = chosen.value;
    const chosenSize = chosen?.dataset.size || inferSize(chosen?.textContent);

    scope.querySelectorAll('[data-lc-size-option]').forEach((button) => {
      const size = button.dataset.lcSizeOption;
      const available = options.some((option) => option.dataset.size === size && isAvailable(option));
      if (available) button.removeAttribute('data-unavailable'); else button.setAttribute('data-unavailable', 'true');
      const selected = size === chosenSize;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    scope.querySelectorAll('[data-lc-format-option]').forEach((button) => {
      const sameSize = button.dataset.size === chosenSize;
      button.hidden = !sameSize;
      const selected = String(button.dataset.variantId) === String(chosen?.value);
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    const available = isAvailable(chosen);
    scope.querySelectorAll('[data-lc-add-button]').forEach((button) => {
      button.disabled = !available;
      button.textContent = available ? (button.dataset.availableText || 'Buy Now') : (button.dataset.soldOutText || 'Out of stock');
    });
    const accelerated = scope.querySelector('.lc-accelerated-checkout');
    if (accelerated) accelerated.hidden = !available || getCountry() !== 'CA';
    select.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const fixLinks = () => {
    document.querySelectorAll('a[href]').forEach((link) => {
      let url;
      try { url = new URL(link.href, window.location.origin); } catch (_) { return; }
      if (url.origin !== window.location.origin) return;
      const text = (link.textContent || '').trim().toLowerCase();
      if (url.pathname === '/policies/shipping-policy' || ['shipping', 'shipping policy', 'shipping & delivery', 'shipping and delivery'].includes(text)) link.href = '/pages/shipping-delivery';
      if (url.pathname === '/collections/all') link.href = '/products/londonschoice';
      if (getCountry() === 'US' && url.hash === '#international-waitlist') link.href = '/pages/us-launch-reservation';
      if (url.hash === '#bundles' || url.hash === '#lc-bundles' || text === 'value sets') {
        const item = link.closest('li');
        if (item) item.remove(); else link.remove();
      }
    });
  };
  const removeBrokenBundles = () => document.querySelectorAll('.lc-bundles, #bundles, #lc-bundles').forEach((node) => node.remove());
  const addInternationalCta = () => {
    if (window.location.pathname !== '/' && window.location.pathname !== '') return;
    const purchase = document.querySelector('.lc-hero__purchase');
    if (!purchase || purchase.querySelector('[data-lc-international-cta]')) return;
    const link = document.createElement('a');
    link.dataset.lcInternationalCta = 'true';
    link.textContent = 'Outside Canada? Join the Launch List →';
    link.href = getCountry() === 'US' ? '/pages/us-launch-reservation' : '#international-waitlist';
    link.style.cssText = 'display:inline-flex;margin-top:14px;font-weight:700;text-decoration:underline;text-underline-offset:3px;';
    purchase.appendChild(link);
  };
  const blockUnsupportedCheckout = () => {
    document.addEventListener('click', (event) => {
      if (getCountry() === 'CA') return;
      const checkout = event.target.closest('button[name="checkout"], a[href*="/checkout"]');
      if (!checkout) return;
      event.preventDefault();
      window.location.href = getCountry() === 'US' ? '/pages/us-launch-reservation' : '/#international-waitlist';
    }, true);
  };
  const run = () => {
    document.querySelectorAll('[data-lc-product-scope]').forEach(syncScope);
    removeBrokenBundles();
    fixLinks();
    addInternationalCta();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true }); else run();
  document.addEventListener('shopify:section:load', run);
  blockUnsupportedCheckout();
})();
